export default {
  solutions: {
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Soluzioni',
    hero: {
      eyebrow: 'Soluzioni',
      title: 'La soluzione giusta per ogni immobile',
      lead: 'Casa privata, spazio commerciale o magazzino: troviamo insieme il sistema di telecamere ottimale per le vostre esigenze.',
    },
    grid: {
      eyebrow: 'Soluzioni per immobile a colpo d’occhio',
      title: 'Sei aree, una promessa: vera sicurezza',
      lead: 'Ogni scheda porta a una vista dedicata con punti di sorveglianza tipici e soluzioni tecniche adatte.',
    },
    tag: { privat: 'Privato', gewerbe: 'Aziendale', innen: 'Interno', außen: 'Esterno', neu: 'Nuovo', erweiterung: 'Ampliamento' },
    more: 'Scopri di più',
    cta: {
      title: 'Non sei sicuro di quale soluzione scegliere?',
      lead: 'Analizziamo insieme il vostro immobile e vi consigliamo la giusta combinazione di telecamere, registrazione e accessori.',
      primary: 'Consulenza senza impegno',
      secondary: 'Avvia il pianificatore di telecamere',
    },
  },
};